module.exports = __webpack_public_path__ + "img/viewer.02dfd10e.svg";